'use client'

import Script from 'next/script'

import { isProduction } from '@/lib/constants'

const AdSense = () => {
  if (!isProduction) return null

  const adsenseId = 'ca-pub-2901188880424850'

  return (
    <Script
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseId}`}
      strategy='afterInteractive'
      crossOrigin='anonymous'
    />
  )
}

export default AdSense
